The HTTP request containing the webhook attempt.
